// extracted by css-extract-rspack-plugin
export default {"cls1":"Cta-cls1_LZh","cls2":"Cta-cls2_ZFK Cta-cls1_LZh"};